import { Injectable } from '@angular/core';
import { MapToolsService, ToggleTool, ToolName } from '@techwan/map-tools';
import { Subscription } from 'rxjs';
import { MyDeploymentLayerService } from '../my-deployment-layer/my-deployment-layer.service';

class TogglyMyDeploymentTool extends ToggleTool {
  constructor() {
    super('toggleDeployment', [
      'assets/icons/localize-icons/deployment-point.svg',
      'assets/icons/localize-icons/deployment-point-hide.svg'
    ]);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MyDeploymentToggleButtonControllerService {
  private subs: Subscription[] = [];

  private toggleDeployButton: ToggleTool = null;

  constructor(private mapTools: MapToolsService, private myDeploymentLayer: MyDeploymentLayerService) {}

  init() {
    this.toggleDeployButton = this.mapTools.getTool(ToolName.ToggleDeployment) as ToggleTool;

    this.subs.push(
      this.toggleDeployButton.$event.subscribe(toggleDeployButton =>
        this.myDeploymentLayer.showDeploymentPoint(toggleDeployButton.isActive)
      )
    );
    this.subs.push(this.myDeploymentLayer.$active.subscribe(isActive => this.onMyDeploymentLayerActiveChanged(isActive)));
    this.subs.push(this.myDeploymentLayer.$visible.subscribe(isVisible => this.toggleDeployButton.setActive(isVisible)));
  }

  private onMyDeploymentLayerActiveChanged(isActive: boolean) {
    isActive ? this.mapTools.showTool(this.toggleDeployButton) : this.mapTools.hideTool(this.toggleDeployButton);
  }

  uninit() {
    while (this.subs.length > 0) {
      this.subs.pop().unsubscribe();
    }
  }
}
